export default "__VITE_ASSET__Cso9kTcK__"